define('Responsive/helpers/SwipeableViewDelegateHelper',['require','exports','module','../util/noop','../vendor','../util/dom','../util/renderComplete'],function(require,exports,module){
    var noop = require('../util/noop'),
        ReVendor = require( '../vendor' ),
        ReDom   = require( '../util/dom' ),
        ReRenderComplete = require( '../util/renderComplete' );

    var undef=undefined,
        SPACE=' ',
        COMMA=',',
        _ONE="$1",
        NONE="none",
        PERCENT='%',
        PERCENT100="100%",
        COORDLEFT='(',
        COORDSEP='%,',
        COORDRIGHT=')',
        COORD0="(0,0,0)",
        LINEAR="linear",
        UNDEFINED="undefined",        
        FN = "function",
        EASE_SMOOTH="cubic-bezier(0, 0, 0.2, 1.0)";

    var MathAbs = Math.abs,
        getTiming   = (function() {
    
        var parse=/\s*cubic\-bezier\(([^)]+)\)\s*|.*/,
            presets={
                'linear'        : [ 0.0,  0.0,  1.0,  1.0 ],
                'ease'          : [ 0.0,  0.53, 0.54, 1.0 ],
                'ease-in'       : [ 0.42, 0.0,  1.0,  1.0 ],
                'ease-out'      : [ 0.0,  0.0,  0.58, 1.0 ],
                'ease-mid'      : [ 0.25, 1.0,  1.0,  1.0 ],
                'ease-in-out'   : [ 0.42, 0.0,  0.58, 1.0 ]
            },
                /**
                 *  Cheap... but, lets pre-cache linear, since we don't
                 *  REALLY need a bezier calc for it.
                 */
            cache   = {
                'linear' : function(x){
                    return x;
                }
            },

            filter=function(id){
                    var vals=id.replace(parse,"$1").split(',');
                return vals.length>1 ? vals.map(getFloat) : presets[LINEAR];
            },

            /**
             * Adapted by rmunson from : 
             *  Cubic Bezier CSS3 transitions emulator
             *  See this post for more details
             *  http://st-on-it.blogspot.com/2011/05/calculating-cubic-bezier-function.html
             *
             *  Copyright (C) 2011 Nikolay Nemshilov
             */
            bezierCalc = function(p) {
                // defining the bezier functions in the polynomial form
                var C = {
                        x   : 3 * p[0],
                        y   : 3 * p[1]
                    },
                    B = {
                        x   : 3 * (p[2] - p[0]) - C.x,
                        y   : 3 * (p[3] - p[1]) - C.y
                    },
                    A = {
                        x   : 1 - C.x - B.x,
                        y   : 1 - C.y - B.y
                    },
                    
                    bezier = function(t,p){
                        return t * (C[p] + t * (B[p] + t * A[p]));
                    },
                        // using Newton's method to aproximate the parametric value of x/y for t
                    bezier_der = function(t,p) { 
                        return C[p] + t * (2*B[p] + 3*A[p] * t); 
                    },

                    find_for = function(t,p) {
                        var x=t, i=0, z;
                        
                        for(;i < 5;i++) { // making 5 iterations max
                            z = bezier(x,'x') - t;
                        
                            if (MathAbs(z) < 1e-3){
                                break; // if already got close enough
                            }
                            x = x - z/bezier_der(x,'x');
                        }
                        
                        return x;
                    };
                
                return function(t) {
                    return t <= 0 ? 0 : bezier(find_for(t,'x'),'y');
                }
            };
                                
        return function(id){
            id=id || 'linear';
            return cache[id] || (cache[id]= bezierCalc(presets[id]||filter(id)),cache[id]);
        }
    })(),

    getFloat    =function(val){
        return parseFloat(val);
    },
    coordinateString=function(coords){
        var _coords=coords.slice(0,!ReVendor.use3d ? -1 : undef);
        return ReVendor.translate+COORDLEFT+_coords.join(COORDSEP) +COORDRIGHT
    };

    function SwipeParams(params){
        if(params instanceof SwipeParams){
            return params;
        }
        $.extend(this,params);
        this.coords=this.coords||[0,0,0];
        this.transform=coordinateString(this.coords);
    }

    SwipeParams.prototype={
        easing : EASE_SMOOTH,
        duration : 0,
        callback : noop
    };

    //  These methods are mapped on to the jquery instance object
    //  so, think of them in the context of a collection.
    var helperApi = {
        lastPos     : [0,0,0],
        checkBounds : function(width,NB){
            return !NB ? {'1':true,'-1':true} : {
                '1'   : ~~(this[0].scrollWidth/width) > -1*~~((this.lastPos[0]/(width/this[0].offsetWidth)/100)-1),
                '-1'  : (this.lastPos[0] < 0)
            };
        },
        getPoint    : function(e){
            var points=e.touches && e.touches[0] ||e;
            return {
                pageX   : this.getPercent(points.pageX),
                pageY   : this.getPercent(points.pageY),
                touches : e.touches || []
            };
        },
        getTransformCoords : function(view){
                view=view || this;
                //Trying this out as an alternative;
                return view.lastPos || [0,0,0];
            return coords;
        },
        getPercent : function(px,width){
            return ~~(px/(width || this.width())*100).toFixed(6);
        },
        getViewWidthPercent : function(){
            return 100/(parseInt(this[0].style.width||100,10)/100);
        },

        getViewWidth : function(raw){
            var per=this[0].style.width,
                computed=ReDom.computedWidth(this[0]);

            if(per.indexOf(PERCENT)!==-1 && !raw){
                return (computed/parseFloat(per,10))*100;
            }
            return computed;
        
        },

        animateSwipe : function(params){
            var css={},
                view=this,
                swipeParams=new SwipeParams(params);

            view.lastPos=swipeParams.coords;
            if(!ReVendor.hasTransition){
                this.swipeAnimator(params);
                return;
            }
            if(view.cbrunner){
                clearTimeout(view.cbrunner);
            };
            view[0].style[ReVendor.transitionJS]=[
                ReVendor.transform,
                swipeParams.duration+'s',
                swipeParams.easing, 
                0+'s'
            ].join(SPACE);
            view[0].style[ReVendor.transformJS]=swipeParams.transform;

            if(swipeParams.callback!==noop){
                // view.one(ReVendor.transitionEvent,cb);
                view.cbrunner=setTimeout(function(){
                    ReRenderComplete(swipeParams.callback);
                    // Re.util.removeStyleProperty(view[0],ReVendor.transitionJS);
                },(swipeParams.duration*1000) + (ReVendor.isAndroid ? 200 : 100));

            }    
            return;
        },
        animateSwipeToTarget : function(params){
            params.duration= params.duration!==undefined ? params.duration : 0.8;
            var that=this,
                swipeParams=new SwipeParams(params);
            this.animateSwipe(swipeParams);
        },
        /* Fallback methods for applying animation, if transitions are not supported */    
        swipeAnimator    : function(params){
            var that=this,
                swipeParams=new SwipeParams(params);

            $.easing[swipeParams.easing]=$.easing[swipeParams.easing]||getTiming(swipeParams.easing);
            var props={};

            props.fake=swipeParams.coords[0];
            // note : jquery animate
            // console.log(props,swipeParams,$.easing,this);
            this.animate(props,{
                duration    : swipeParams.duration*1000,
                easing      : swipeParams.easing,
                complete    : function(){
                    ReRenderComplete(swipeParams.callback);
                },
                step        : function(t,fx){
                    // console.log(t,fx);
                    this.style[ReVendor.transformJS]=coordinateString([t,0,0]);
                }
            });
        },
        easeOut : getTiming('ease')
    };

    return function(swipeableViewDelegate,_view){
        var view=_view || {},
            $view;

        if(swipeableViewDelegate.control){
            swipeableViewDelegate.destroy();
            swipeableViewDelegate.control[0]=view;
            return swipeableViewDelegate.control;
        }
        $view=$(view).extend(helperApi);
        $view.swipeableViewDelegate = swipeableViewDelegate;
        return $view;
    }
});
